import { localeStrings as strings } from 'applicationConfig';

const footerMenuData = [
  {
    title: strings.footerLinks.legalAndRegulatory.caption,
    items: [
      { text: strings.footerLinks.legalAndRegulatory.links.termsUse, url: '/help/terms-of-use' },
      {
        text: strings.footerLinks.legalAndRegulatory.links.legalNotice,
        url: 'https://www.tpicap.com/legal-and-regulatory/legal-notices'
      },
      {
        text: strings.footerLinks.accessibilityAndPrivacy.links.privacyPolicy,
        url: 'https://www.tpicap.com/legal-and-regulatory/privacy-policy'
      }
    ]
  }
];

export default footerMenuData;



// WEBPACK FOOTER //
// ./src/containers/layouts/MainLayout/footerMenuData.js